import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	sortedTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortedTooltipNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortPromptTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortPromptTooltipNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortPromptDefaultTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortedDefaultAscendingTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortedDefaultDescendingTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sortedTooltip: {
		id: 'native-issue-table.table-header-row.sort-headers.sorted-tooltip',
		defaultMessage: 'Sorted {sortDescription}',
		description: 'Tooltip for sorting, sortDescription is like "A -> Z"',
	},
	sortedTooltipNew: {
		id: 'native-issue-table.table-header-row.sort-headers.sorted-tooltip-new',
		defaultMessage:
			'Sorted {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}',
		description: 'Tooltip for sorting, sortDescription is like "A -> Z"',
	},
	sortPromptTooltip: {
		id: 'native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip',
		defaultMessage: 'Sort {sortDescription}',
		description:
			'Tooltip for sorting, when it has not been sorted, to prompt users to hit sort. sortDescription is like "A -> Z"',
	},
	sortPromptTooltipNew: {
		id: 'native-issue-table.table-header-row.sort-headers.sort-prompt-tooltip-new',
		defaultMessage:
			'Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}',
		description:
			'Tooltip for sorting, when it has not been sorted, to prompt users to hit sort. sortDescription is like "A -> Z"',
	},
	sortPromptDefaultTooltip: {
		id: 'native-issue-table.table-header-row.sort-headers.sort-prompt-default-tooltip',
		defaultMessage: 'Sort in ascending order',
		description:
			'If no sort description is provided, this prompts the user to sort in ascending order',
	},
	sortedDefaultAscendingTooltip: {
		id: 'native-issue-table.table-header-row.sort-headers.sorted-default-ascending-tooltip',
		defaultMessage: 'Sorted in ascending order',
		description:
			'If no sort description is provided, this informs the user that it is sorted in ascending order',
	},
	sortedDefaultDescendingTooltip: {
		id: 'native-issue-table.table-header-row.sort-headers.sorted-default-descending-tooltip',
		defaultMessage: 'Sorted in descending order',
		description:
			'If no sort description is provided, this informs the user that it is sorted in descending order',
	},
});
export default messages;
